import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Icon, Tooltip } from '@salesforce/design-system-react';

import './AggregateBlock.scss';

export class AggregateBlock extends Component {
  render() {
    const { title, value, tooltip } = this.props;
    const titleTooltip = (
      <Tooltip
        className="aggregate-tooltip"
        align="bottom"
        content={tooltip}
        position="overflowBoundaryElement"
      >
        <button className="slds-button tooltip-trigger-button">
          <Icon
            assistiveText={{ label: 'More Information' }}
            category="utility"
            name="info"
            size="x-small"
          />
        </button>
      </Tooltip>
    );

    return (
      <div className="aggregate-block slds-col slds-size_1-of-2">
        <h2 className="aggregate-title">
          <span className="title-text">
            {title} {tooltip ? titleTooltip : null}
          </span>
        </h2>
        <h3 className="aggregate-value">{value}</h3>
      </div>
    );
  }
}

AggregateBlock.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  tooltip: PropTypes.string,
  children: PropTypes.element,
  location: PropTypes.object
};

export default AggregateBlock;
